import fetch from '@/plugins/axios'
export default {
	namespaced: true,
	state: {
		list: [],
		pager: {},
		partnerDetail: {}
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		}
	},
	actions: {
		// 添加快递员
		async addPartner({ commit }: any, params: any) {
			return await fetch({
				url: '/client/partner',
				method: 'post',
				data: params
			})
			
		},
		// 修改快递员
		async modifyPartner({ commit }: any, params: any) {
			return await fetch({
				url: `/client/partner/${params.id}`,
				method: 'put',
				data: params.data
			})
			
		},
		// 获取快递员详情
		async getPartnerDetail({ commit }: any, id: any) {
			const res = await fetch({
				url: `/client/partner/${id}`
			})
			console.log(res);
			commit('setState',{key:'partnerDetail',data: res})
		},
		// 获取快递员列表
		async getPartnerList({ commit }: any, params: any) {
			const res:any = await fetch({
				url: '/client/partner',
				method: 'get',
				params
			})
			commit('setState',{key:'list',data: res.docs})
			commit('setState',{key:'pager',data: {limit: res.limit,total: res.total}})
		},
		// 快递员充值
		async partnerRecharge({ commit }: any, params: any) {
			return await fetch({
				url: `/client/partner/recharge/${params.id}`,
				method: 'put',
				data: params.data
			})
		},
		// 快递员排序
		async partnerSort({ commit }: any, params: any){
			return await fetch({
				url: `/client/partner/sort/${params.id}`,
				method: 'put',
				data: params.data
			})
		},
		// 改变快递员状态
		async changePartnerStatus({ commit }: any, id: any){
			return await fetch({
				url: `/client/partner/state/${id}`,
				method: 'put',
			})
		},
		// 删除快递员
		async deletePartner({ commit }: any, id: any){
			return await fetch({
				url: `/client/partner/${id}`,
				method: 'delete',
			})
		},
		// 解绑快递员
		async unbindPartner({ }, id: string) {
			return await fetch({
				url: `/client/unbindPartner/${id}`,
				method: 'put',
			})
		}
	}
}